<script>
import GenericCustomMasterDataAutocompleteV2 from '@/components/generic/GenericCustomMasterDataAutocompleteV2.vue'
import Utils from '@/common/Utils';
import Constants from '@/common/Constants';
import InputText from 'primevue/inputtext';
import LabelField from '@/components/generic/LabelField.vue';

export default {
    components: { GenericCustomMasterDataAutocompleteV2, LabelField },
    props: ['proposal', 'lotProposal', 'actual'],
    emits: [ 'applyProposal' ],
    data(){
        return {
            proposalApplyAllRecords: {}
        }
    },
    mounted(){
        this.createData();
    },
    created(){
    },
    methods: {
        createData(){
            this.proposalApplyAllRecords = {
              incotermApply: true,
              incotermCode: null,

              billofLadingHolderApply: true,
              billofLadingHolder: this.lotProposal.consignee,

              notifyAddressApply: true,
              notifyAddress: this.lotProposal.notifyAddress,

              charterPartyDatedApply: true,
              charterPartyDated: this.lotProposal.charterPartyDated ? Utils.dateToCurrentTimeZone(this.lotProposal.charterPartyDated) : null,

              productTradeDescriptionApply: true,
              productTradeDescription: this.lotProposal.product,
              idPortOrLocationOfDischargeApply: true,
              idPortOrLocationOfDischarge: null,
              portorLocationofFiscalDestinationDescription: this.lotProposal.portOfDischarge,

              quantityParsedApply: true,
              quantityParsed: this.lotProposal.quantityParsed,

              idDestinationTaxWarehouse: null,
              idDestinationTaxWarehouseApply : true,
              destinationTaxWarehouseLabel: ""
            };

            if(this.lotProposal.eadConsignee && this.lotProposal.eadPlaceOfDelivery){
              this.proposalApplyAllRecords.destinationTaxWarehouse = `${this.$t('VesselNomination.parcel.eadConsignee')}:${this.lotProposal.eadConsignee}, ${this.$t('VesselNomination.parcel.eadPlaceOfDelivery')}:${this.lotProposal.eadPlaceOfDelivery}`;
            }else if(this.lotProposal.eadConsignee){
              this.proposalApplyAllRecords.destinationTaxWarehouse = `${this.$t('VesselNomination.parcel.eadConsignee')}:${this.lotProposal.eadConsignee}`;
            }else if(this.lotProposal.eadPlaceOfDelivery){
              this.proposalApplyAllRecords.destinationTaxWarehouse = `${this.$t('VesselNomination.parcel.eadPlaceOfDelivery')}:${this.lotProposal.eadPlaceOfDelivery}`;
            }else{
              this.proposalApplyAllRecords.destinationTaxWarehouse = "";
            }
        },
        emitApply(){
          this.proposalApplyAllRecords.portOrLocationOfDischarge = this.$refs.proposalOpPortOfDischargeCombo.getCompleteValue() ? this.$refs.proposalOpPortOfDischargeCombo.getCompleteValue().label : "";
          this.proposalApplyAllRecords.destinationTaxWarehouseLabel = this.$refs.proposalOpDestinationTaxWarehouseCombo.getCompleteValue() ? this.$refs.proposalOpDestinationTaxWarehouseCombo.getCompleteValue().label : "";
          this.$emit("applyProposal", this.proposalApplyAllRecords);
        }
    },
    computed: {
        utils: () => Utils,
        constants: () => Constants,


        taxWarehouseQueryValue(){
          let qv = this.lotProposal.eadConsignee?.replaceAll(' ', '') + '|';
          if(this.lotProposal.eadPlaceOfDelivery){
            qv += this.lotProposal.eadPlaceOfDelivery?.replaceAll(' ', '');
          }
          return qv;
        }
    }
}

</script>

<template>
  <Card class="m-1">
    <template #title>{{$t('incoterm.fk')}}</template>
    <template #content>
      <div class="grid">
        <div class="col-12 lg:col-6">
          <LabelField class="w-full mt-1" label="Attuale" :value="actual.incotermCode" /> 
          <LabelField class="w-full mt-1" label="Email" :value="proposal.incoterm" /> 
        </div>
        <div class="col-10 lg:col-5">
            <GenericCustomMasterDataAutocompleteV2
              v-model="proposalApplyAllRecords.incotermCode"
              ref="proposalOpIncotermCombo"
              :queryValue="proposal.incoterm"
              name="vessel-nomination-incoterm-combo"
              api="masterdata/incoterm-combo"
              :class="{'w-full p-inputtext-sm mt-1 ': true}" />
        </div>
        <div class="col-2 lg:col-1 field pt-4">
            <Checkbox v-model="proposalApplyAllRecords.incotermApply" :binary="true" />
        </div>
      </div>
    </template>
  </Card>

<Card class="m-1">
  <template #title>{{$t('movementInstructions.charterPartyDated')}}</template>
  <template #content>
    <div class="grid">
      <div class="col-12 lg:col-6">
        <LabelField class="w-full mt-1" label="Attuale" :value="actual.charterPartyDated ? utils.formatDate(utils.dateToCurrentTimeZone(actual.charterPartyDated)): ''" /> 
        <LabelField class="w-full mt-1" label="Email" :value="lotProposal.charterPartyDated ? utils.formatDate(utils.dateToCurrentTimeZone(lotProposal.charterPartyDated)): lotProposal.charterPartyDatedString" /> 
      </div>
      <div class="col-10 lg:col-5">
          <Calendar 
            v-model="proposalApplyAllRecords.charterPartyDated"
            :showIcon="true" :showButtonBar="true" :yearNavigator="true"
            :dateFormat="constants.DATE_FORMAT"
            :class="{'w-full p-inputtext-sm mt-1 ': true}" />
      </div>
      <div class="col-2 lg:col-1 field pt-4">
          <Checkbox v-model="proposalApplyAllRecords.charterPartyDatedApply" :binary="true" />
      </div>
    </div>
  </template>
</Card>
  
<Card class="m-1">
  <template #title>{{$t('movementInstructions.billOfLadingHolder')}}</template>
  <template #content>
    <div class="grid">
      <div class="col-12 lg:col-6">
        <LabelField class="w-full mt-1" label="Attuale" :value="actual.billofLadingHolder" /> 
        <LabelField class="w-full mt-1" label="Email" :value="lotProposal.consignee" /> 
      </div>
      <div class="col-10 lg:col-5">
          <InputText
            v-model="proposalApplyAllRecords.billofLadingHolder"
            :class="{'w-full p-inputtext-sm mt-1 ': true}" />
      </div>
      <div class="col-2 lg:col-1 field pt-4">
          <Checkbox v-model="proposalApplyAllRecords.billofLadingHolderApply" :binary="true" />
      </div>
    </div>
  </template>
</Card>

<Card class="m-1">
  <template #title>{{$t('movementInstructions.notifyCompleteAddress')}}</template>
  <template #content>
    <div class="grid">
      <div class="col-12 lg:col-6">
        <LabelField class="w-full mt-1" label="Attuale" :value="actual.notifyAddress" /> 
        <LabelField class="w-full mt-1" label="Email" :value="lotProposal.notifyAddress" /> 
      </div>
      <div class="col-10 lg:col-5">
          <InputText
            v-model="proposalApplyAllRecords.notifyAddress"
            :class="{'w-full p-inputtext-sm mt-1 ': true}" />
      </div>
      <div class="col-2 lg:col-1 field pt-4">
          <Checkbox v-model="proposalApplyAllRecords.notifyAddressApply" :binary="true" />
      </div>
    </div>
  </template>
</Card>

<Card class="m-1">
  <template #title>{{$t('movementInstructions.productTradeDescription')}}</template>
  <template #content>
    <div class="grid">
      <div class="col-12 lg:col-6">
        <LabelField class="w-full mt-1" label="Attuale" :value="actual.productTradeDescription" /> 
        <LabelField class="w-full mt-1" label="Email" :value="lotProposal.product" /> 
      </div>
      <div class="col-10 lg:col-5">
        <InputText
            v-model="proposalApplyAllRecords.productTradeDescription"
            :class="{'w-full p-inputtext-sm mt-1 ': true}" />
      </div>
      <div class="col-2 lg:col-1 field pt-4">
        <Checkbox v-model="proposalApplyAllRecords.productTradeDescriptionApply" :binary="true" />
      </div>
    </div>
  </template>
</Card>

<Card class="m-1">
  <template #title>{{$t('movementInstructions.destination')}}</template>
  <template #content>
    <div class="grid">
      <div class="col-12 lg:col-6">
        <LabelField class="w-full mt-1" label="Attuale" :value="actual.portOrLocationOfDischarge" /> 
        <LabelField class="w-full mt-1" label="Email" :value="lotProposal.portOfDischarge" /> 
      </div>
      <div class="col-10 lg:col-5">
        <GenericCustomMasterDataAutocompleteV2
          v-model="proposalApplyAllRecords.idPortOrLocationOfDischarge"
          ref="proposalOpPortOfDischargeCombo"
          :queryValue="lotProposal.portOfDischarge?.split(' ')[0].replace(',', '').replace('.', '').replace('-', '')"
          name="vessel-nomination-port-and-location-combo"
            api="masterdata/port-and-location-combo"
          :class="{'w-full p-inputtext-sm mt-1 ': true}" />
      </div>
      <div class="col-2 lg:col-1 field pt-4">
        <Checkbox v-model="proposalApplyAllRecords.idPortOrLocationOfDischargeApply" :binary="true" />
      </div>
    </div>
  </template>
</Card>

<Card class="m-1">
  <template #title>{{$t('movementInstructions.quantity')}}</template>
  <template #content>
    <div class="grid">
      <div class="col-12 lg:col-6">
        <LabelField class="w-full mt-1" label="Attuale" :value="actual.quantity" /> 
        <LabelField class="w-full mt-1" label="Email" :value="lotProposal.quantity" /> 
      </div>
      <div class="col-10 lg:col-5">
        <InputNumber
          v-model="proposalApplyAllRecords.quantityParsed"
                    :minFractionDigits="3"
                    :maxFractionDigits="3"
          :class="{'w-full p-inputtext-sm mt-1 ': true}" />
      </div>
      <div class="col-2 lg:col-1 field pt-4">
            <Checkbox v-model="proposalApplyAllRecords.quantityParsedApply" :binary="true" />
      </div>
    </div>
  </template>
</Card>

<Card class="m-1">
  <template #title>{{$t('taxWarehouse.fk')}}</template>
  <template #content>
    <div class="grid">
      <div class="col-12 lg:col-6">
        <LabelField class="w-full mt-1" label="Attuale" :value="actual.destinationTaxWarehouse" /> 
        <LabelField class="w-full mt-1" label="Email" :value="proposalApplyAllRecords.destinationTaxWarehouse" /> 
      </div>
      <div class="col-10 lg:col-5">
        <GenericCustomMasterDataAutocompleteV2
            v-model="proposalApplyAllRecords.idDestinationTaxWarehouse"
            ref="proposalOpDestinationTaxWarehouseCombo"
            :queryValue="taxWarehouseQueryValue"
            name="vessel-nomination-tax-warehouse-combo"
              api="masterdata/tax-warehouse-combo"
            :class="{'w-full p-inputtext-sm mt-1 ': true}" />
      </div>
      <div class="col-2 lg:col-1 field pt-4">
        <Checkbox v-model="proposalApplyAllRecords.idDestinationTaxWarehouseApply" :binary="true" />
      </div>
    </div>
  </template>
</Card>


    <!-- <div class="grid"> -->
        <!-- <div class="col-1"/>
        <Divider layout="vertical" />
        <div class="col-3 field">
          Attuale
        </div>
        <Divider layout="vertical" />
        <div class="col-3 field">
          Vessel Nomination
        </div>
        <Divider layout="vertical" />
        <div class="col-3">
          Proposto
        </div>
        <div class="col-1" />

        <div class="col-1">
          <label>{{$t('incoterm.fk')}}</label>
        </div>
        <Divider layout="vertical" />
        <div class="col-3 field">
            <label class="w-full mt-1">{{ actual.incotermCode }}</label> 
        </div>
        <Divider layout="vertical" />
        <div class="col-3 field">
            <label class="w-full mt-1">{{ proposal.incoterm }}</label> 
        </div>
        <Divider layout="vertical" />
        <div class="col-3 field ">
            <GenericCustomMasterDataAutocompleteV2
              v-model="proposalApplyAllRecords.incotermCode"
              ref="proposalOpIncotermCombo"
              :queryValue="proposal.incoterm"
              name="vessel-nomination-incoterm-combo"
              api="masterdata/incoterm-combo"
              :class="{'w-full p-inputtext-sm mt-1 ': true}" />
        </div>
        <Divider layout="vertical" />
        <div class="col-1 field pt-4">
            <Checkbox v-model="proposalApplyAllRecords.incotermApply" :binary="true" />
        </div> -->

        <!-- <div class="col-1">
          <label>{{$t('movementInstructions.billOfLadingHolder')}}</label>
        </div>
        <Divider layout="vertical" />
        <div class="col-3 field">
            <label class="w-full mt-1">{{ actual.billofLadingHolder }}</label> 
        </div>
        <Divider layout="vertical" />
        <div class="col-3 field">
            <label class="w-full mt-1">{{ lotProposal.consignee }}</label> 
        </div>
        <Divider layout="vertical" />
        <div class="col-3 field ">
            <InputText
              v-model="proposalApplyAllRecords.billofLadingHolder"
              :class="{'w-full p-inputtext-sm mt-1 ': true}" />
        </div>
        <Divider layout="vertical" />
        <div class="col-1 field pt-4">
            <Checkbox v-model="proposalApplyAllRecords.billofLadingHolderApply" :binary="true" />
        </div> -->

        <!-- <div class="col-1">
          <label>{{$t('movementInstructions.notifyCompleteAddress')}}</label>
        </div>
        <Divider layout="vertical" />
        <div class="col-3 field">
            <label class="w-full mt-1">{{ actual.notifyAddress }}</label> 
        </div>
        <Divider layout="vertical" />
        <div class="col-3 field">
            <label class="w-full mt-1">{{ lotProposal.notifyAddress }}</label> 
        </div>
        <Divider layout="vertical" />
        <div class="col-3 field ">
            <InputText
              v-model="proposalApplyAllRecords.notifyAddress"
              :class="{'w-full p-inputtext-sm mt-1 ': true}" />
        </div>
        <Divider layout="vertical" />
        <div class="col-1 field pt-4">
            <Checkbox v-model="proposalApplyAllRecords.notifyAddressApply" :binary="true" />
        </div> -->
        

        <!-- <div class="col-1">
          <label>{{$t('movementInstructions.productTradeDescription')}}</label>
        </div>
        <Divider layout="vertical" />
        <div class="col-3 field">
            <label class="w-full mt-1">{{ actual.productTradeDescription }}</label> 
        </div>
        <Divider layout="vertical" />
        <div class="col-3 field">
            <label class="w-full mt-1">{{ lotProposal.product }}</label> 
        </div>
        <Divider layout="vertical" />
        <div class="col-3 field ">
            <InputText
              v-model="proposalApplyAllRecords.productTradeDescription"
              :class="{'w-full p-inputtext-sm mt-1 ': true}" />
        </div>
        <Divider layout="vertical" />
        <div class="col-1 field pt-4">
            <Checkbox v-model="proposalApplyAllRecords.productTradeDescriptionApply" :binary="true" />
        </div> -->

        <!-- <div class="col-1">
          <label>{{$t('movementInstructions.destination')}}</label>
        </div>
        <Divider layout="vertical" />
        <div class="col-3 field">
            <label class="w-full mt-1">{{ actual.portOrLocationOfDischarge }}</label> 
        </div>
        <Divider layout="vertical" />
        <div class="col-3 field">
            <label class="w-full mt-1">{{ lotProposal.portOfDischarge }}</label> 
        </div>
        <Divider layout="vertical" />
        <div class="col-3 field ">
            <GenericCustomMasterDataAutocompleteV2
              v-model="proposalApplyAllRecords.idPortOrLocationOfDischarge"
              ref="proposalOpPortOfDischargeCombo"
              :queryValue="lotProposal.portOfDischarge?.split(' ')[0].replace(',', '').replace('.', '').replace('-', '')"
              name="vessel-nomination-port-and-location-combo"
                api="masterdata/port-and-location-combo"
              :class="{'w-full p-inputtext-sm mt-1 ': true}" />
        </div>
        <Divider layout="vertical" />
        <div class="col-1 field pt-4">
            <Checkbox v-model="proposalApplyAllRecords.idPortOrLocationOfDischargeApply" :binary="true" />
        </div> -->

        <!-- <div class="col-1">
          <label>{{$t('movementInstructions.quantity')}}</label>
        </div>
        <Divider layout="vertical" />
        <div class="col-3 field">
            <label class="w-full mt-1">{{ actual.quantity }}</label> 
        </div>
        <Divider layout="vertical" />
        <div class="col-3 field">
            <label class="w-full mt-1">{{ lotProposal.quantity }}</label> 
        </div>
        <Divider layout="vertical" />
        <div class="col-3 field ">
            <InputNumber
              v-model="proposalApplyAllRecords.quantityParsed"
                        :minFractionDigits="3"
                        :maxFractionDigits="3"
              :class="{'w-full p-inputtext-sm mt-1 ': true}" />
        </div>
        <Divider layout="vertical" />
        <div class="col-1 field pt-4">
            <Checkbox v-model="proposalApplyAllRecords.quantityParsedApply" :binary="true" />
        </div> -->

        <!-- <div class="col-1">
          <label>{{$t('taxWarehouse.fk')}}</label>
        </div>
        <Divider layout="vertical" />
        <div class="col-3 field">
            <label class="w-full mt-1">{{ actual.destinationTaxWarehouse }}</label> 
        </div>
        <Divider layout="vertical" />
        <div class="col-3 field">
            <label class="w-full mt-1">{{ proposalApplyAllRecords.destinationTaxWarehouse }}</label> 
        </div>
        <Divider layout="vertical" />
        <div class="col-3 field ">
          <GenericCustomMasterDataAutocompleteV2
              v-model="proposalApplyAllRecords.idDestinationTaxWarehouse"
              ref="proposalOpDestinationTaxWarehouseCombo"
              :queryValue="taxWarehouseQueryValue"
              name="vessel-nomination-tax-warehouse-combo"
                api="masterdata/tax-warehouse-combo"
              :class="{'w-full p-inputtext-sm mt-1 ': true}" />
        </div>
        <Divider layout="vertical" />
        <div class="col-1 field pt-4">
            <Checkbox v-model="proposalApplyAllRecords.idDestinationTaxWarehouseApply" :binary="true" />
        </div>
      </div> -->


      <Toolbar>
        <template #end>
            <Button class="field m-1" label="Applica Tutti" icon="pi pi-check" variant="outlined"  @click="emitApply" />
        </template>
      </Toolbar>
</template>

